<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-6 title-page" tabindex="0">Recuperação de Senha</div>
                    <p class="mt-8 mb-n1" tabindex="0">
                        Informe o seu e-mail de acesso para iniciar a recuperação da sua senha.
                    </p>
                </v-col>
            </v-row>
            <v-form ref="form" v-model="validForm">
                <v-row>
                    <v-col>
                        <v-text-field dense id="username" label="E-mail" tabindex="0" 
                            aria-label="Digite seu email para fazer a recuperação de sua senha" 
                            v-model="dataset.data.email" required
                            :rules="[$rules.required, $rules.email]" outlined hide-details="auto"
                            @blur="dataset.data.email = (dataset.data.email || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-form>
            <v-row no-gutters class="mb-4">
                <v-col class="d-flex align-center">
                    <v-checkbox v-model="isProcurador" hide-details="auto">
                        <template v-slot:label>
                            <strong>Procurador</strong>
                        </template>
                    </v-checkbox>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-5 ml-3" small :color="'primary'" v-bind="attrs"
                                v-on="on">mdi-help-circle</v-icon>
                        </template>
                        <span>Caso sua conta seja de um procurador, selecione essa opção.</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-btn color="primary" @click.native="finish" :loading="loading" tabindex="0" 
                aria-label="Botão para enviar a solicitação de recuperação de senha">Finalizar</v-btn>
            <v-btn color="grey" text @click.native="goBack" tabindex="0"
            aria-label="Botão para cancelar e não solicitar nova senha de acesso">Cancelar</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from "@/main";

import axios from "axios"

import router from '../../router';

export default {
    data: () => ({
        loading: false,
        validForm: false,
        isProcurador: false,
        dataset: {
            data: {}
        }
    }),

    mounted: function () {
    },

    created() {
        this.dataset.data = {}
    },

    methods: {

        goBack() {
            eventHub.$emit('DIALOG-FORGOT-PASSWORD', false)
        },

        async finish() {

            if (!this.$refs.form.validate()) return;

            let data = {
                email: (this.dataset.data.email || '').trim(),
            };

            const url = this.isProcurador ? '/api/lawyers/forgot-password' : '/api/users/forgot-password';

            this.loading = true;

            try {
                const result = await axios.post(url, data);

                if (!result.data.status) throw new Error();

                await this.$dialog.confirm({
                    text: 'E-mail enviado com sucesso! Siga as instruções enviadas para recuperar sua conta.',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                })

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.data = {}
                this.loading = false;
            }
        },

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}
</style>
